import ManagementCampaignContainer from './ManagementCampaignContainer';

export default ManagementCampaignContainer;
